import { NgModule } from '@angular/core';
import { AlertComponent } from './alert/alert.component';
import { FormsModule, NgForm } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { HomeComponent } from './home/home.component';
import { StudyComponent } from './study/study.component';
import { LoginComponent } from './login/login.component';
import { AppendComponent } from './append/append.component';
import { ModalComponent } from './modal/modal.component';
import { AdminComponent } from './admin/admin.component';
import { QWangEditorComponent } from './q-wang-editor/q-wang-editor.component';
import { InputAlertComponent } from './input-alert/input-alert.component';

@NgModule({
  declarations: [
    HomeComponent,
    AlertComponent,
    StudyComponent,
    LoginComponent,
    AppendComponent,
    ModalComponent,
    AdminComponent,
    QWangEditorComponent,
    InputAlertComponent,
  ],

  imports: [
    FormsModule,
    ModalModule.forRoot(),
    CommonModule,
    RouterModule
  ],

  exports: [


  ],
  providers: [

  ],
})
export class PagesModule { }
